import { render, staticRenderFns } from "./KodeBantu.vue?vue&type=template&id=14f9b90e"
import script from "./KodeBantu.vue?vue&type=script&lang=js"
export * from "./KodeBantu.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./KodeBantu.vue?vue&type=style&index=1&id=14f9b90e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports